var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lucky-page page"
  }, [_c('m-head'), _c('div', {
    staticClass: "lucky-main page-main"
  }, [_c('div', {
    staticClass: "lucky-list"
  }, [_c('div', {
    staticClass: "lucky-item",
    on: {
      "click": function ($event) {
        return _vm.onSkip('/airdrop');
      }
    }
  }, [_c('div', {
    staticClass: "wow fadeInDown",
    attrs: {
      "data-wow-duration": "0.4s"
    }
  }, [_c('m-lucky-item', {
    attrs: {
      "url": require('@images/lucky-icon-airdrop.jpg'),
      "name": "AIRDROP"
    }
  })], 1)]), _c('div', {
    staticClass: "lucky-item"
  }, [_c('div', {
    staticClass: "wow fadeInDown",
    attrs: {
      "data-wow-duration": "0.6s"
    },
    on: {
      "click": function ($event) {
        return _vm.onSkip('/bot');
      }
    }
  }, [_vm.hasActive !== null ? _c('div', {
    staticClass: "lucky-item-tag"
  }, [!_vm.hasActive ? _c('span', [_vm._v("New")]) : _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.storageInfo.stock.percent)) + "%")])]) : _vm._e(), _c('m-lucky-item', {
    attrs: {
      "url": require('@images/lucky-icon-minibot.jpg'),
      "name": "MINTBOT"
    }
  })], 1)]), _c('div', {
    staticClass: "lucky-item"
  }, [_vm._m(0), _c('div', {
    staticClass: "wow fadeInDown",
    attrs: {
      "data-wow-duration": "0.6s"
    },
    on: {
      "click": function ($event) {
        return _vm.onSkip('/botcode');
      }
    }
  }, [_c('m-lucky-item', {
    attrs: {
      "url": require('@images/lucky-icon-botcode.jpg'),
      "name": "BOTCODE"
    }
  })], 1)]), _c('div', {
    staticClass: "lucky-item"
  }, [_c('div', {
    staticClass: "wow fadeInDown",
    attrs: {
      "data-wow-duration": "0.6s"
    },
    on: {
      "click": function ($event) {
        return _vm.onSkip('/turn');
      }
    }
  }, [_c('m-lucky-item', {
    attrs: {
      "url": require('@images/lucky-icon-lucky.jpg'),
      "name": "LUCKY"
    }
  })], 1)]), _c('div', {
    staticClass: "lucky-item",
    on: {
      "click": function ($event) {
        return _vm.onSkip('/slotMachine');
      }
    }
  }, [_c('div', {
    staticClass: "wow fadeInDown",
    attrs: {
      "data-wow-duration": "0.8s"
    }
  }, [_c('m-lucky-item', {
    attrs: {
      "url": require('@images/lucky-icon-mathine.jpg'),
      "name": "SLOT"
    }
  })], 1)]), _c('div', {
    staticClass: "lucky-item",
    on: {
      "click": function ($event) {
        return _vm.onSkip('/gifts');
      }
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "wow fadeInDown",
    attrs: {
      "data-wow-duration": "0.8s"
    }
  }, [_c('m-lucky-item', {
    attrs: {
      "url": require('@images/lucky-icon-gift.jpg'),
      "name": "GIFTS"
    }
  })], 1)])])]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lucky-item-tag"
  }, [_c('span', [_vm._v("New")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lucky-item-tag"
  }, [_c('span', [_vm._v("New")])]);
}];
export { render, staticRenderFns };